import { createSelector } from '@ngrx/store';
import { LoadedState, WorkflowState } from './state.state';

// Subscription

export const selectLoadedFeature = (state: { loaded: LoadedState }) =>
  state.loaded;

export const selectIsSubscriptionActive = createSelector(
  selectLoadedFeature,
  (loadedState: LoadedState) => loadedState.subscription,
);

export const selectIsProfileActive = createSelector(
  selectLoadedFeature,
  (loadedState: LoadedState) => loadedState.profile,
);

// Profile

export const selectProfileFeature = (state: { profile: WorkflowState }) =>
  state.profile;

export const selectAppProfile = createSelector(
  selectProfileFeature,
  (workflowState: WorkflowState) => workflowState?.profile?.appProfile,
);

// Conversation

export const selectConversationFeature = (state: {
  conversation: WorkflowState;
}) => state.conversation;

export const selectConversation = createSelector(
  selectConversationFeature,
  (workflowState: WorkflowState) => workflowState?.conversation,
);

// Workflow

export const selectWorkflowFeature = (state: { workflow: WorkflowState }) =>
  state.workflow;

export const selectWorkflow = createSelector(
  selectWorkflowFeature,
  (workflowState: WorkflowState) => workflowState?.workflow,
);

export const selectWorkflowId = createSelector(
  selectWorkflowFeature,
  (workflowState: WorkflowState) => workflowState?.workflow.uid,
);

export const selectIsWorkflowActive = createSelector(
  selectLoadedFeature,
  (loadedState: LoadedState) => loadedState?.workflow,
);

export const selectWorkflowPayload = createSelector(
  selectWorkflowFeature,
  (workflowState: WorkflowState) => {
    const worfklowPayload = {
      workflowPayload: {
        name: workflowState?.workflow?.name,
        status: workflowState?.workflow?.status,
        activeStep: workflowState?.workflow?.activeStep,
        step: workflowState?.workflow?.step,
        promptWorkflow: workflowState?.workflow?.promptWorkflow,
        resultEditing: workflowState?.workflow?.resultEditing,
      },
    };
    return worfklowPayload;
  },
);

// Upload

export const selectUpload = (state: { upload: WorkflowState }) => state.upload;

// Upload

export const selectProcess = (state: { process: WorkflowState }) =>
  state.process;
